var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var moment = require('moment');
var DashboardNavMyGi = require('./dashboardNavMyGi.jsx');
var DashboardChartMyGi = require('./dashboardChartMyGi.jsx');
var DashboardSideMyGi = require('./dashboardSideMyGi.jsx');
var SurveyEntryMyGi = require('./surveyEntryMyGi.jsx');

var DashboardWithDataMyGi = createReactClass({
    mixins: [PureRenderMixin],

    componentDidUpdate: function(){
        if(!this.equalizer){
            this.equalizer = new Foundation.Equalizer($('#dashboardEqualizer'));
            Foundation.IHearYou();
        }else{
            this.equalizer.$element.foundation('_reflow');
        }
    },

    componentWillUnmount: function(){
        $('#dashboardEqualizer').foundation('destroy');
    },

    getitemScoresDataList: function() {
        var itemScoresDataList = [];

        if(this.props.activeItems.length){
            this.props.activeItems.forEach(function(activeItem){
                itemScoresDataList.push(this.props.id2ItemScoresData[activeItem.id]);
            }.bind(this));
        }else{
            this.props.score.data.forEach(function(scoreItem){
                if(scoreItem.percentile > 0){
                    itemScoresDataList.push(this.props.id2ItemScoresData[scoreItem.item.id]);
                }
            }.bind(this));
        }

        return itemScoresDataList;
    },

    render: function(){
        var shouldShowDashboardSide = this.props.activeItems.length === 1 || this.props.daysBeforeLatestSurvey !== 0;
        return (
            <div className="dashboard-with-data">
                <div className="content-header-wrapper">
                    <div className="content-header-small content-header row">
                        <div className="medium-6 column">
                            <h1>MyGi</h1>
                        </div>
                        <div className="medium-6 column show-for-medium">
                            <p className="ops">
                                <span className="ion-clock"></span>
                                <span>last updated {moment(this.props.latestTimeStamp).calendar()}</span>
                                <SurveyEntryMyGi
                                    daysBeforeLatestSurvey={this.props.daysBeforeLatestSurvey}
                                    clickTracking={this.props.clickTracking}/>
                            </p>
                        </div>
                    </div>
                </div>
                <div id="dashboardEqualizer" className="row medium-collapse" data-equalizer="bar">
                    <div className="column">
                        <DashboardNavMyGi
                            score={this.props.score}
                            activeItems={this.props.activeItems}
                            addActiveItem={this.props.addActiveItem}
                            removeActiveItem={this.props.removeActiveItem}
                            setActiveItems={this.props.setActiveItems}
                            id2ItemScoresData={this.props.id2ItemScoresData}
                            daysBeforeLatestSurvey={this.props.daysBeforeLatestSurvey}
                            isSnapShot={this.props.isSnapShot}
                            clickTracking={this.props.clickTracking}
                        />
                    </div>
                    <div id="chartContentWrapper" className="column">
                        <div id="chartContent" className="row medium-collapse">
                            <div className="large-9 column" data-equalizer-watch="bar">
                                <DashboardChartMyGi
                                    itemScoresDataList={this.getitemScoresDataList()}
                                    activeItems={this.props.activeItems}
                                    clickTracking={this.props.clickTracking}
                                />
                            </div>
                            <div className="large-3 column end" data-equalizer-watch="bar">
                                {shouldShowDashboardSide &&
                                    <DashboardSideMyGi
                                        activeItems={this.props.activeItems}
                                        id2ItemScoresData={this.props.id2ItemScoresData}
                                        daysBeforeLatestSurvey={this.props.daysBeforeLatestSurvey}
                                        clickTracking={this.props.clickTracking}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
});

module.exports = DashboardWithDataMyGi;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/dashboardWithDataMyGi.jsx